/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  LaunchCampaignMutationResponse,
  LaunchCampaignPathParams,
  LaunchCampaign400,
} from '../types/LaunchCampaign'

function getLaunchCampaignUrl({
  bison_campaign_id,
}: {
  bison_campaign_id: LaunchCampaignPathParams['bison_campaign_id']
}) {
  const res = {
    method: 'POST',
    url: `/api/v1/emailbison/campaigns/${bison_campaign_id}/launch/` as const,
  }
  return res
}

/**
 * @description Launch/resume a campaign.
 * This starts a paused or draft campaign so it begins sending emails.
 * @summary Launch or resume a campaign
 * {@link /api/v1/emailbison/campaigns/:bison_campaign_id/launch/}
 */
export async function launchCampaign(
  {
    bison_campaign_id,
  }: { bison_campaign_id: LaunchCampaignPathParams['bison_campaign_id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    LaunchCampaignMutationResponse,
    ResponseErrorConfig<LaunchCampaign400>,
    unknown
  >({
    method: 'POST',
    url: getLaunchCampaignUrl({ bison_campaign_id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
